import { restHelper } from '../helpers/rest.helper';


const Save = async (payload) => {
    let response = await restHelper.post('api/StartupFounder/Save', payload);
    return response;
}

const Delete = async (payload) => {
    let response = await restHelper.post('api/StartupFounder/Delete', payload);
    return response;
}

const Edit = async (payload) => {
    let response = await restHelper.post('api/StartupFounder/Edit', payload);
    return response;
}


export default {
    Edit,
    Save,
    Delete
}